var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 67,
    viewBox: "0 0 75 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 21152"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.325 19.5417C69.325 11.8326 63.0757 5.58333 55.3667 5.58333H19.6333C11.9243 5.58333 5.67501 11.8326 5.67501 19.5417V24.0083C5.67501 25.5501 4.42512 26.8 2.88334 26.8C1.34156 26.8 0.0916748 25.5501 0.0916748 24.0083V19.5417C0.0916748 8.74908 8.84076 0 19.6333 0H55.3667C66.1593 0 74.9083 8.74908 74.9083 19.5417V24.0083C74.9083 25.5501 73.6585 26.8 72.1167 26.8C70.5749 26.8 69.325 25.5501 69.325 24.0083V19.5417Z",
    fill: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.9908 32.6824C55.081 31.5922 55.081 29.8245 53.9908 28.7343L45.0013 19.7449C40.8585 15.6021 34.1418 15.6021 29.9989 19.7449L21.0094 28.7343C19.9192 29.8246 19.9192 31.5922 21.0094 32.6824C22.0996 33.7726 23.8673 33.7726 24.9575 32.6824L33.9469 23.6929C35.9093 21.7306 39.0909 21.7306 41.0534 23.6929L50.0428 32.6824C51.133 33.7726 52.9006 33.7726 53.9908 32.6824Z",
    fill: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.5 67C35.9583 67 34.7084 65.7501 34.7084 64.2083V32.9416C34.7084 31.3998 35.9583 30.15 37.5 30.15C39.0418 30.15 40.2917 31.3998 40.2917 32.9416V64.2083C40.2917 65.7501 39.0418 67 37.5 67Z",
    fill: "#D5D5D5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.d41609ef044ae0dd0f7e6f337ae25323.svg";
export { ForwardRef as ReactComponent };